import JiraStatusTag from "./JiraStatusTag";

export default JiraStatusTag;
